var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400" },
      model: {
        value: _vm.removeModal,
        callback: function ($$v) {
          _vm.removeModal = $$v
        },
        expression: "removeModal",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            {
              staticClass: "primary white--text",
              class: {
                headline: !_vm.isMobilePort,
                "caption mobile-title": _vm.isMobilePort,
              },
            },
            [
              _vm._v("\n            Delete Note / Bookmark\n            "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-icon",
                {
                  staticClass: "primary white--text",
                  on: {
                    click: function ($event) {
                      _vm.removeModal = false
                    },
                  },
                },
                [_vm._v("close")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c("v-col", { staticClass: "text-center" }, [
                    _vm.isEnterpriseAdminAction()
                      ? _c("p", { staticClass: "mb-0 mt-5" }, [
                          _vm._v(
                            "\n                        Are you sure you want to delete this public note from " +
                              _vm._s(_vm.getNoteCreatorName()) +
                              "? It will be\n                        removed for everyone in your Enterprise.\n                    "
                          ),
                        ])
                      : _c("p", { staticClass: "mb-0 mt-5" }, [
                          _vm._v(
                            "\n                        Are you sure you want to remove this note?\n                    "
                          ),
                        ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      _vm.removeModal = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error", loading: _vm.isDeleting },
                  on: { click: _vm.deleteNote },
                },
                [_vm._v("Delete")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }